import React from "react";
import { Link } from "react-router-dom";
import WaveMotif from "@/components/WaveMotif";
import Logo from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col" data-testid="page-404">
      <div className="container-narrow pt-8">
        <Link to="/" aria-label="Quantum Results — home"><Logo className="h-14 w-auto" /></Link>
      </div>
      <div className="relative flex-1 flex items-center overflow-hidden">
        <WaveMotif className="absolute inset-x-0 bottom-0 h-[420px] w-full opacity-70" />
        <div className="relative container-narrow py-24">
          <div className="max-w-2xl">
            <div className="eyebrow mb-6">404</div>
            <h1 className="display text-[42px] sm:text-[60px]">
              This isn't quite the path you were looking for.
            </h1>
            <p className="prose-qr mt-8">
              But every meaningful journey includes a wrong turn or two. Take a
              moment, then choose where you'd like to go next.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/"
                data-testid="404-home"
                className="inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-brand-cream text-[14px] hover:bg-brand-blue transition-colors"
              >
                Return home
              </Link>
              <Link
                to="/contact"
                data-testid="404-contact"
                className="inline-flex items-center gap-2 text-[14px] text-brand-ink/70 hover:text-brand-blue"
              >
                Reach out to us →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
